// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.

import { Application } from "stimulus"
import EventsController from "./events_controller"
import ReadmoreController from "./readmore_controller";

const application = Application.start()
application.register("events", EventsController);
application.register("readmore", ReadmoreController);
